import React from 'react';
import Svg from '../Svg';

const IconBrush03 = ({ ...props }) => (
  <Svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.56811 1C5.31572 0.999973 5.06993 0.999943 4.86178 1.01695L5.56811 1ZM4.86178 1.01695C4.63318 1.03563 4.36345 1.07969 4.09202 1.21799L4.86178 1.01695ZM5.01145 3.01145C5.01107 3.0156 5.01069 3.02 5.01031 3.02464C5.00078 3.14122 5.00001 3.30348 5.00001 3.60001V9H19V3.60001C19 3.30348 18.9992 3.14122 18.9897 3.02464C18.9893 3.02 18.9889 3.0156 18.9886 3.01145C18.9844 3.01107 18.98 3.01069 18.9754 3.01031C18.8588 3.00078 18.6965 3.00001 18.4 3.00001H5.60001C5.30348 3.00001 5.14122 3.00078 5.02464 3.01031C5.02 3.01069 5.0156 3.01107 5.01145 3.01145ZM13.5 16H10.5V19.5C10.5 20.3284 11.1716 21 12 21C12.8284 21 13.5 20.3284 13.5 19.5V16ZM8.50001 16V19.5C8.50001 21.433 10.067 23 12 23C13.933 23 15.5 21.433 15.5 19.5V16"
    />
  </Svg>
);

export default IconBrush03;
